import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import _ from 'lodash';
import { useSelector } from 'react-redux';

import showToastNotification from '../widgets/toastify';
import * as Constants from '../../helpers/constants';
import { ApiHelper } from '../../helpers/apihelper';

const initialState = {
  showModal: false,
  email: '',
  emailMessage: '',
  errors: {},
};

const LoginWhitelist = ({ client }) => {
  const [state, setState] = useState(initialState);
  const id = useSelector((state) => state.user.id);
  const userName = useSelector(state => state.user.name);

  const validateForm = () => {
    let err = {};
    if (!state.email.trim()) {
      err['email'] = 'Please enter a valid email';
    }
    if (Object.keys(err).length) {
      setState((prevState) => ({ ...prevState, errors: err }));
      setTimeout(() => {
        setState((prevState) => ({ ...prevState, errors: {} }));
      }, 2000);
      return false;
    }
    return true;
  };

  const handleSaveChanges = (param) => () => {
    if (validateForm()) {
      let requestBody = {
        action: param,
        user_id: id,
        crm_user_data: {
          user_id: id,
          name: userName
        },
        client_secret: Constants.CLIENT_SECRET,
        email: state.email,
      };

      let body = _.pick(requestBody, ApiHelper(client, 'LOGIN_WHITELIST').API_BODY);
      ApiHelper(client, 'LOGIN_WHITELIST').API(client, body)
        .then((response) => {
          if (response.status === Constants.CO_API.FAILED) {
            showToastNotification({
              message: 'failed',
              isSuccess: false,
            });
          } else if (response.status === Constants.CO_API.SUCCESS) {
            setState(prevState => ({
              ...prevState,
              emailMessage: response.data.email?.status,
            }));
            setTimeout(() => {
              setState(prevState => ({
                ...prevState,
                emailMessage: '',
              }));
            }, 2000);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const onEmailValueChange = (e) => {
    setState(prevState => ({ ...prevState, email: e.target.value }));
  };

  const handleShowModal = () => {
    setState(prevState => ({ ...prevState, showModal: true }));
  };

  const handleCloseModal = () => setState(initialState);

  return (
    <>
      <Button
        variant="outline-primary"
        onClick={handleShowModal}
      >
        Login Whitelist
      </Button>
      <Modal
        show={state.showModal}
        onHide={handleCloseModal}
      >
        <Modal.Header closeButton>
          <Modal.Title className='fs-6 fw-bold'>Login Whitelist</Modal.Title>
        </Modal.Header>
        <Modal.Body className='modal-body-bg-color'>
          <Form>
            <div className='row'>
              <Form.Group
                className='d-flex'
              >
                <div className='col-md-3'>
                  <Form.Label className='w-100 py-2'>Email:</Form.Label>
                </div>
                <div className='col-md-9'>
                  <Form.Control
                    type="email"
                    placeholder="Email"
                    onChange={onEmailValueChange}
                  />
                  {state.errors ? <p className='text-danger m-0'>{state.errors.email}</p> : null}
                  <p className='m-0'>{state.emailMessage ?? null} </p>
                </div>
              </Form.Group>
            </div>
            <Modal.Footer>
              <Button
                variant="outline-primary"
                onClick={handleSaveChanges('add')}
              >
                Whitelist
              </Button>
              <Button
                variant="outline-primary"
                onClick={handleSaveChanges('check')}
              >
                Check
              </Button>
              <Button
                variant="outline-primary"
                onClick={handleSaveChanges('remove')}
              >
                Delist
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default LoginWhitelist;
